export default __webpack_public_path__ + "static/media/logoDark.36e51625.png";